import { $black } from './commonColors';

const primaryMain = '#73000A';
const primaryMainOpacity = 'rgba(115, 0, 10, 0.9)';
const secondaryMain = $black;
const secondaryMainOpacity = 'rgba(0, 0, 0, 0.5)';
const secondaryLight = '#FFCC00';
const tertiaryMain = '#50000A';

export const palette = {
  primaryMain,
  primaryMainOpacity,
  primaryText: primaryMain,
  secondaryMain,
  secondaryMainOpacity,
  secondaryLight,
  secondaryText: secondaryMain,
  tertiaryMain,
  logoContainerMobile: {
    height: 30,
    marginBottom: 20
  },
  formNavBar: {
    currentStepButtonTextColor: tertiaryMain
  }
};
